export enum ParticipantSubType {
  Referee = 'referee',
  Athlete = 'athlete',
  Coach = 'coach',
  Director = 'director',
  AthleteCoach = 'athlete/coach',
}
